//https://vuejs.org/v2/guide/mixins.html
//debo encontrar la forma  de ser capaz de modificar algunos valores, que no sean siempre estaticos
//por otro lado, para los methodos, encontrar alguna forma de suscribir o llamar(invocar un callback)
//por ejemolo al llamar a page y headersUpdated que invoquen al metodo que yo deseo
const PaginationWithRangeMix={
    data() {
        return {
            pagination: {
                columnName:'rfc',
                sortOrder:'ASC',
                rfc:'',
                page: 1,                //currentPage
                listaPageSize:[10,20,30,50,100,200],
                pageSize: 10 ,//page size de la primera vez, tiene que coincidide con 
                actualShow:0,
                collectionSize: 0, //tamaño del resultado,
                range: {
                    start: new Date(2019, 1, 16), //  
                    end: new Date()    // desde ahora
                }
            },
        }
    },
    methods: {
        /**
         * Esta funcion me ayuda a limpiar el request, son datos que no interesan.
         */
        getPaginationSearch(){
            let pagination= Object.assign({},this.pagination);
            delete pagination.listaPageSize;
            delete pagination.actualShow;
            delete pagination.collectionSize;
            return pagination;
        },        
    }
}

export {PaginationWithRangeMix}
//eslint-disable-next-line
const PaginationMix={
    data() {
        return {
            pagination: {
                columnName:'rfc',
                sortOrder:'ASC',
                rfc:'',
                page: 1,                //currentPage
                listaPageSize:[10,20],
                pageSize: 10 ,//page size de la primera vez, tiene que coincidide con 
                actualShow:0,
                collectionSize: 0, //tamaño del resultado,
            },
        }
    }
}